import React from 'react'
import './banner.css';

function Banner() {
    return (
        <>
            <div className='banner'>
                <h3>A creative coalition focused on art development and movement for an artist's journey</h3>
                <h5>• s o l i t u d e • c e n t e r • r e l e a s e • </h5>
            </div>
        </>
    )
}

export default Banner